import type { Selector } from 'core/core.selectors';
import type { SeasonState } from './season.models';

export const getSeasonEntitiesInEntities: Selector<SeasonState['entities']> = state => state.entities.season.entities;
